/**
 * Created by Ivan on 17.05.2026
 */

const SeasonPassCompletedTasksWindow = Prefab.createWindow(
    "season_pass_completed_tasks_window",
    "completed_tasks_window_prefab_json",
    {
        theme: (mission) => bundles[`season_pass_${mission.logic.period}`].jsons[`theme_${mission.logic.period}`],
        bundles: SeasonPassLogic.listWindowBundles
    }
);
